import React, { useEffect, useState } from 'react';
import TextInfo, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_KIND,
} from '@/bit/components/components.text';
import FormTemplate, { THEMES } from '@/components/formTemplate';
import { useFieldArray } from 'react-hook-form';
import Operation from '@/containers/chooseOperationArr/operation';
import { MOBILE_LINE_ACTIONS, OPERATION } from '@/constants/operation';

function ChooseOperation({
  title = 'Configuración de tus líneas',
  control,
  lines,
  step = null,
  showForm = true,
  showHelpInfo = false,
  withHorizontalSeparator = false,
  watch,
  setValue,
  nextStep,
  shipping = null,
  forceHideSimTypes = null,
}) {
  const [linesLineActions, setLinesLineActions] = useState([]);
  const { fields } = useFieldArray({
    name: OPERATION.ID,
    control,
  });
  useEffect(() => {
    const newLinesLineActions = [];
    if (Array.isArray(lines)) {
      lines.forEach((line) => {
        newLinesLineActions.push(line?.lineActions);
      });
    }
    setLinesLineActions(newLinesLineActions);
  }, [lines]);

  // Metodo que actualiza la lista de opciones a migrar en funcion de lo que se vaya seleccionando
  const handleLineActionOnChange1 = (fieldIndex, data) => {
    const newlinesLineActions = linesLineActions;
    const lineActions = newlinesLineActions[fieldIndex];
    const { value: optionSelected } = { ...data };
    const { selectValue } = { ...optionSelected };
    const { value } = { ...selectValue };
    // En el array de opciones del select marcamos la seleccion
    if (value) {
      newlinesLineActions[fieldIndex] = lineActions.map((action) => {
        const { options } = action;
        if (Array.isArray(options)) {
          return {
            ...action,
            options: options.map((option) => {
              return {
                ...option,
                isChecked: value === option?.mobileNumber,
              };
            }),
          };
        }
        return action;
      });
    }
    setLinesLineActions((prevLinesLineActions) =>
      // Actualizamos el resto opciones de los selectores para no permitir elegir la opcion previamente elegida
      newlinesLineActions.map((newLineActions, index) => {
        if (index !== fieldIndex) {
          return prevLinesLineActions[index]?.map((action, indexLineAction) => {
            const { options } = { ...action };
            const { options: originalOptions } = {
              ...lines[index]?.lineActions[indexLineAction],
            };
            const checkedMobileNumber = options?.find(
              (item) => item.isChecked
            )?.mobileNumber;
            const originalOptionsWithOutSelectValue = originalOptions?.filter(
              (item) => item.mobileNumber !== value
            );
            const originalOptionsWithOutValueKeepCheckedOption =
              originalOptionsWithOutSelectValue?.map((item) => {
                return {
                  ...item,
                  isChecked: checkedMobileNumber === item?.mobileNumber,
                };
              });
            return {
              ...action,
              options: originalOptionsWithOutValueKeepCheckedOption,
            };
          });
        }
        return newLineActions;
      })
    );
  };
  const handleLineActionOnChange = (fieldIndex, data) => {
    let newlinesLineActions = linesLineActions;
    const lineActions = newlinesLineActions[fieldIndex];
    const { value: optionSelected } = { ...data };
    const { selectValue } = { ...optionSelected };
    const { value } = { ...selectValue };
    // En el array de opciones del select marcamos la seleccion
    if (value) {
      newlinesLineActions[fieldIndex] = lineActions.map((action) => {
        const { options } = action;
        if (Array.isArray(options)) {
          return {
            ...action,
            options: options.map((option) => {
              return {
                ...option,
                isChecked: value === option?.mobileNumber,
              };
            }),
          };
        }
        return action;
      });
      // si se elige una linea previamente seleccionada se des selecciona en el campo anteriormente seleccinada
      newlinesLineActions = newlinesLineActions.map((newLineActions, index) => {
        if (index !== fieldIndex) {
          return newLineActions?.map((action) => {
            const { options } = { ...action };
            return {
              ...action,
              options: options?.map((option) => {
                const { mobileNumber, isChecked } = { ...option };
                if (mobileNumber === value && isChecked) {
                  const fieldValue = watch(
                    `${OPERATION.ID}.${index}.${OPERATION.ACTION_CHOICER.ID}`
                  );
                  if (fieldValue?.value === MOBILE_LINE_ACTIONS.MIGRATION) {
                    setValue(
                      `${OPERATION.ID}.${index}.${OPERATION.ACTION_CHOICER.ID}`,
                      {
                        ...fieldValue,
                        selectValue: null,
                      }
                    );
                  }
                  const optionCalculated = {
                    ...option,
                    isChecked: false,
                  };
                  return optionCalculated;
                }
                return option;
              }),
            };
          });
        }
        return newLineActions;
      });
    }
    setLinesLineActions(newlinesLineActions);
  };

  return (
    <div className="choose-operation-container">
      <FormTemplate
        step={step}
        titleText={title}
        theme={showForm ? THEMES.FULL : THEMES.LONG}
        withHorizontalSeparator={withHorizontalSeparator}
      >
        {!showForm &&
          showHelpInfo &&
          Array.isArray(lines) &&
          lines.length > 0 &&
          lines.map((line) => (
            <TextInfo
              className="choose-operation-desc"
              key={line?.id}
              text={line?.label}
              kind={TEXT_KIND.PARAGRAPH}
              color={TEXT_COLOR.GREY5}
              size={TEXT_SIZE.CAPTION2}
            />
          ))}
        {showForm &&
          fields.map((field, index) => {
            const { id, simTypes, operation, label, type } = field;
            return (
              <Operation
                key={id}
                id={OPERATION.ID}
                nestIndex={index}
                lineActions={linesLineActions[index]}
                lineActionOnChange={handleLineActionOnChange1}
                simTypes={simTypes}
                operation={operation}
                title={lines.length > 1 ? label : ''}
                type={type}
                watch={watch}
                defaultLineAction={field[OPERATION.ACTION_CHOICER.ID] || null}
                nextStep={nextStep}
                forceHideSimTypes={forceHideSimTypes}
                {...{ control }}
              />
            );
          })}
        {shipping && shipping}
      </FormTemplate>
      <style jsx>
        {`
          .choose-operation-container {
            margin-bottom: 12px;
            :global(.choose-operation-desc) {
              margin: 0px 0px 8px 0px;
            }
          }
        `}
      </style>
    </div>
  );
}
export default ChooseOperation;
